<template>
  <footer class="border-t border-gray-800">
    <div class="container mx-auto flex justify-between flex-col md:flex-row px-4 py-6 capitalize text-gray-400">
      <div class="">
        <h3 class="tracking-wide" v-html="name"></h3>
      </div>
      <div class="">
        Made With ❤️ Htoo Aung Phyo Lwin
      </div>
      <div class="">Follow Me: <a href="https://www.facebook.com/htooaung.phyolwin.100/" class="text-blue-500" target="_blank"><i class="fa-brands ml-3 fa-facebook-square"></i></a></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterBar",
  data() {
    return {
      name: '',
    }
  },
  created() {
    let getYear = new Date().getFullYear();
    this.name = `Copyright &copy; ${getYear} All rights reserved.`;
  }
}
</script>

<style scoped>

</style>